module.exports = __webpack_public_path__ + "static/media/nps_image_none.bb236af9.svg";